import { Home, Label, Person, Settings } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { appLink, Lang } from 'cdx-common';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../libraries/SessionProvider';
import { NoProductIcon } from './AppItems';

export default () => {
    const [state, setState] = React.useState(false);
    const navigate = useNavigate();
    const { isSuperAdmin } = useSession();
    const toggleDrawer =
        (open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event.type === 'keydown' &&
                    ((event as React.KeyboardEvent).key === 'Tab' ||
                        (event as React.KeyboardEvent).key === 'Shift')
                ) {
                    return;
                }

                setState(open);
            };


    return (
        <div>
            <React.Fragment>
                <Button
                    aria-label="Ouvrir le menu principal"
                    onClick={toggleDrawer(true)}
                    sx={{ minWidth: { xs: 40, sm: 64 }, px: { xs: 0.5, sm: 1 } }}
                >
                    <MenuIcon />
                    <Box
                        alt="Construction CDX"
                        component="img"
                        src="./assets/cdx_logo_v.svg"
                        sx={{ display: { xs: 'none', sm: 'block' }, height: 60, width: 100 }}
                    />
                </Button>
                <Drawer
                    anchor={'left'}
                    open={state}
                    onClose={toggleDrawer(false)}
                >
                    <Box
                        sx={{ width: 250 }}
                        role="presentation"
                        onClick={toggleDrawer(false)}
                        onKeyDown={toggleDrawer(false)}
                    >
                        <Box
                            sx={{
                                alignItems: 'center',
                                display: { xs: 'flex', sm: 'none' },
                                justifyContent: 'center',
                                minHeight: 88,
                                px: 2,
                                pt: 1
                            }}
                        >
                            <Box
                                alt="Construction CDX"
                                component="img"
                                src="./assets/cdx_logo_v.svg"
                                sx={{ height: 72, maxWidth: '100%', objectFit: 'contain', width: 140 }}
                            />
                        </Box>
                        <List>
                            <ListItem key={'/'} disablePadding onClick={() => { navigate(appLink('home', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <Home />
                                    </ListItemIcon>
                                    <ListItemText primary={"Accueil"} />
                                </ListItemButton>
                            </ListItem>
                            {/*<ListItem key={'/project/list'} disablePadding onClick={() => { navigate(appLink('projectList', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <AppItemAvatar type={AppModels.projects} model={undefined} sx={{ width: 20 }} />
                                    </ListItemIcon>
                                    <ListItemText primary={"Projets"} />
                                </ListItemButton>
                            </ListItem>*/}
                            <ListItem key={'/users'} disablePadding onClick={() => { navigate(appLink('users', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <Person />
                                    </ListItemIcon>
                                    <ListItemText primary={Lang('users', { ucf: true })} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem key={'scanProductsMode'} disablePadding onClick={() => { navigate(appLink('scanProductsMode', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        {NoProductIcon}
                                    </ListItemIcon>
                                    <ListItemText primary={Lang('titrePriseInventaire', { ucf: true })} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem key={'/labeler'} disablePadding onClick={() => { navigate(appLink('labeler', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <Label />
                                    </ListItemIcon>
                                    <ListItemText primary={Lang('titleEtiqueteuse', { ucf: true })} />
                                </ListItemButton>
                            </ListItem>
                            {isSuperAdmin && <ListItem key={'/settings'} disablePadding onClick={() => { navigate(appLink('parametres', null)); }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <Settings />
                                    </ListItemIcon>
                                    <ListItemText primary={"Paramètres"} />
                                </ListItemButton>
                            </ListItem>}
                        </List>
                    </Box>
                </Drawer>
            </React.Fragment>
        </div>
    );
};
